import { useRef, useEffect } from "react";
import api from "../../utils/api";
import SubscribeButton from "../../components/SubscribeButton";

const GUEST_USER_ID = "000000000000000000000000";

/*
  Global sound state
  Once user enables sound, it stays enabled
  across all shorts during session.
*/
let globalSoundEnabled = false;

export default function ShortsItem({
  data,
  isActive,
  currentUser,
}) {
  const videoRef = useRef(null);
  const viewSentRef = useRef(false);

  const userId = currentUser?._id || GUEST_USER_ID;
  const videoId = data?._id;

  const videoSrc =
    data?.video ||
    data?.videoUrl ||
    data?.videoURL ||
    data?.video_url ||
    "";

  const posterSrc =
    data?.image ||
    data?.thumbnail ||
    data?.poster ||
    "";

  /* ===== CHANNEL INFO ===== */

  const channelName =
    data?.channelName ||
    data?.channel?.channelName ||
    data?.channelTitle ||
    "Channel";

  const channelAvatar =
    data?.channelImage ||
    data?.channel?.image ||
    data?.profileImage ||
    `https://ui-avatars.com/api/?name=${channelName}`;

  const channelId =
    data?.channelId ||
    data?.channel?._id ||
    data?.channel?.channelId ||
    null;

  const isSubscribed = data?.isSubscribed ?? false;

  const caption = data?.caption || data?.title || "";

  /* ================= AUTO PLAY + IMPRESSION ================= */
  useEffect(() => {
    const v = videoRef.current;
    if (!v || !videoSrc) return;

    if (isActive) {
      v.muted = !globalSoundEnabled;
      v.play().catch(() => {});

      if (!viewSentRef.current && videoId) {
        viewSentRef.current = true;

        api.post("/api/reels/impression", {
          videoId,
          userId,
        }).catch(() => {});

        api.post("/api/reels/watch-event", {
          videoId,
          userId,
          watchType: "START",
        }).catch(() => {});
      }
    } else {
      v.pause();
      v.currentTime = 0;
      viewSentRef.current = false;
    }
  }, [isActive, videoSrc, videoId, userId]);

  /* ================= TAP CONTROL ================= */
  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;

    if (!globalSoundEnabled) {
      globalSoundEnabled = true;
      v.muted = false;
      v.play().catch(() => {});
      return;
    }

    if (v.paused) {
      v.play().catch(() => {});
    } else {
      v.pause();
    }
  };

  return (
    <div
      onClick={togglePlay}
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        background: "#000",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 420,
          height: "100%",
          aspectRatio: "9 / 16",
          position: "relative",
          borderRadius: 30,
          overflow: "hidden",
        }}
      >
        {/* VIDEO */}
        <video
          ref={videoRef}
          src={videoSrc}
          poster={posterSrc}
          muted
          loop
          playsInline
          preload="metadata"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        {/* GRADIENT */}
        <div
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            height: "35%",
            background:
              "linear-gradient(to top, rgba(0,0,0,0.85), rgba(0,0,0,0))",
          }}
        />

        {/* CHANNEL INFO + SUBSCRIBE */}
        <div
          style={{
            position: "absolute",
            left: 16,
            bottom: 20,
            color: "#fff",
            zIndex: 5,
            maxWidth: "85%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 10,
              marginBottom: 6,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <img
                src={channelAvatar}
                alt="channel"
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #fff",
                }}
              />

              <div
                style={{
                  fontWeight: 600,
                  fontSize: 14,
                }}
              >
                {channelName}
              </div>
            </div>

            {channelId && (
              <div
                onClick={(e) => e.stopPropagation()} // ? prevent video pause
              >
                <SubscribeButton
                  channelId={channelId}
                  initialSubscribed={isSubscribed}
                  small
                />
              </div>
            )}
          </div>

          {caption && (
            <div
              style={{
                fontSize: 13,
                opacity: 0.95,
                lineHeight: 1.4,
              }}
            >
              {caption}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}